<template>
	<div class="legal-page">
		<div
			class="section-header"
			:style="{ backgroundColor: theme.mainColor, color: theme.altTextColor }"
		>
			<h1>
				{{ localization.creditApp.termsOfUseTitle[customerAppBasic.language] }}
			</h1>
		</div>
		<main :style="{ backgroundColor: 'white', color: theme.mainTextColor }">
			<button
				class="language-change"
				@click="languageChange"
			>
				{{ localizationOposite }} <i class="fas fa-globe"></i>
			</button>
			<div class="main-section">
				<p id="legal-term-instruction">
					{{ localization.creditApp.termsOfUseInstruction[customerAppBasic.language] }}
				</p>
				<AccordionList
					:list="terms"
					listLabel="termsLabel"
					:closeOtherOnOpen="true"
					v-if="terms && !isBusy"
				>
					<template #listHeader="{ headerItem }">
						<button
							@click="handleTermsCheckbox(headerItem, $event)"
							class="terms-checkbox-button"
						>
							<i
								:class="{
									'far fa-check-square': headerItem.isChecked,
									'far fa-square': !headerItem.isChecked,
								}"
							></i>
						</button>
					</template>
					<template #listBody="{ bodyItem }">
						<p v-html="bodyItem.termsText"></p>
						<!--{{bodyItem.termsText}}-->
					</template>
				</AccordionList>
				<!--<div class="text-show" ref="disclosure" @scroll="scrollAgreementValidation()">{{terms}}</div>-->
				<div
					class="loading"
					v-if="isBusy"
				>
					<LoaderComponent />
				</div>
			</div>
			<div class="bottom-section">
				<button
					class="button-full"
					:style="{
						backgroundColor: theme.successButtonColor,
						color: theme.successButtonTextColor,
					}"
					@click="acceptTerms"
					:disabled="!allTermsAccepted"
				>
					{{ localization.buttonLabels.acceptTerms[customerAppBasic.language] }}
				</button>
			</div>
		</main>
		<!--<footer :style="{backgroundColor: theme.secondaryColor, color: theme.secondaryTextColor}">
        <button class="button-full" :style="{backgroundColor: theme.successButtonColor, color: theme.successButtonTextColor}" @click="acceptTerms">{{localization.buttonLabels.acceptTerms[customerAppBasic.language]}}</button>
        <div>Powered by <span>Saturn</span></div>
    </footer>-->
	</div>
</template>

<script>
	import ApplicationsSettingsLoader from '@core/classes/Applications/ApplicationsSettingsLoader';
	import LOCALIZATION from '@core/classes/Localization';
	import AccordionList from '@core/components/AccordionList.vue';
	import LoaderComponent from '@core/components/UI/LoaderComponent.vue';
	export default {
		name: 'CreditAppLegal',
		props: ['customerAppBasic', 'acceptTerms', 'terms'],
		data() {
			return {
				theme: {},
				loginError: false,
				isLoading: false,
				acceptDisabled: true,
				disclosure: null,
			};
		},
		computed: {
			allTermsAccepted() {
				return this.terms?.every(term => term.isChecked);
			},
			localization() {
				return LOCALIZATION;
			},
			localizationOposite() {
				this.$parent.createTermsList();
				if (this.customerAppBasic.language == 'Spanish') {
					return 'English';
				} else {
					return 'Español';
				}
			},
			isBusy() {
				return this.terms == null;
			},
		},
		created() {
			this.theme = this.customerAppBasic.storeInfo.theme ?? ApplicationsSettingsLoader.ApplicationSettings.theme;
			// this.theme = ApplicationsSettingsLoader.ApplicationSettings.theme
			setTimeout(() => {
				this.disclosure = this.$refs.disclosure;
			}, 100);
		},
		methods: {
			handleTermsCheckbox(item, e) {
				event.stopPropagation();

				this.$parent.terms = this.terms.map(term => {
					if (term.id === item.id) {
						return { ...term, isChecked: !term.isChecked };
					} else {
						return term;
					}
				});
			},
			languageChange() {
				if (this.customerAppBasic.language == 'English') {
					this.customerAppBasic.language = 'Spanish';
				} else {
					this.customerAppBasic.language = 'English';
				}
				this.$parent.createTermsList();
			},
			//scrollAgreementValidation() {
			//    if (this.$refs.disclosure) {
			//        let currentScroll = this.$refs.disclosure.scrollTop + this.$refs.disclosure.offsetHeight
			//        if ((currentScroll - 10) < this.$refs.disclosure.scrollHeight && (currentScroll + 10) > this.$refs.disclosure.scrollHeight) {
			//            this.acceptDisabled = false
			//        }
			//    } else {
			//        this.acceptDisabled = true
			//    }
			//},
		},
		components: {
			AccordionList,
			LoaderComponent,
		},
	};
</script>
<style></style>
